import { ReactNode } from 'react';
import { Skeleton, Space, Spin } from 'antd';
import { LeftOutlined, RightOutlined, HomeOutlined, LoadingOutlined } from '@ant-design/icons';
import { H2 } from 'components/new-ui/base/typography/styles';
import PackageIcon from 'components/icons/PackageIcon';
import Button from 'components/new-ui/base/button/Button';

export type ProductsNavigationTypes = 'master-items' | 'house-consignments' | 'house-consignments-product' | 'items';

const iconByType: Record<ProductsNavigationTypes, ReactNode> = {
    items: <PackageIcon />,
    'master-items': <PackageIcon />,
    'house-consignments': <HomeOutlined />,
    'house-consignments-product': <HomeOutlined />,
};

type ProdProps = {
    type: ProductsNavigationTypes;
    disabledPrev: boolean;
    disabledNext: boolean;
    productIndex?: number | string;
    typeIndex?: number;
    loading?: boolean;
    onPrev: () => void;
    onNext: () => void;
};

const ProductsNavigation = ({
    disabledPrev,
    disabledNext,
    onPrev,
    onNext,
    type = 'items',
    productIndex,
    typeIndex,
    loading = false,
}: ProdProps) => {
    let label = `Item ${productIndex} Details`;
    if (type === 'master-items') label = `Master Item ${productIndex}`;
    if (type === 'house-consignments') label = `House Consignment ${typeIndex}`;
    if (type === 'house-consignments-product') label = `House Consignment ${typeIndex} | Item ${productIndex}`;

    const navigationLabel = type === 'house-consignments' ? 'Consignment' : 'Item';
    const icon = iconByType[type];
    const isLoadingIndex = productIndex === undefined && type !== 'house-consignments';

    return (
        <Space size={16} align="center">
            <Space size={8}>
                <div
                    style={{
                        background: 'var(--brand-1)',
                        color: 'var(--brand-6)',
                        padding: 8,
                        borderRadius: 6,
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    {icon}
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {isLoadingIndex ? (
                        <Skeleton.Input active size="small" style={{ width: 150, display: 'flex' }} />
                    ) : (
                        <H2>{label}</H2>
                    )}
                </div>
            </Space>

            <div style={{ display: 'flex', alignItems: 'center' }}>
                <Space size={8} style={{ display: 'inline-flex', alignItems: 'center', userSelect: 'none' }}>
                    <span style={{ display: 'inline-flex' }}>
                        <Button type="link" icon={<LeftOutlined />} disabled={disabledPrev || loading} onClick={onPrev}>
                            Prev {navigationLabel}
                        </Button>
                    </span>
                    <span style={{ display: 'inline-flex' }}>
                        <Button type="link" disabled={disabledNext || loading} onClick={onNext}>
                            Next {navigationLabel} <RightOutlined />
                        </Button>
                    </span>

                    {loading && <Spin size="small" indicator={<LoadingOutlined />} />}
                </Space>
            </div>
        </Space>
    );
};

export default ProductsNavigation;
